module.exports = __webpack_public_path__ + "static/media/leftArrow.3e482d96.svg";